//# sourceMappingURL=/s/files/1/0319/0859/3723/t/11/assets/custom.js.map?v=1663287998

// form submission script by the DigilynxMohsin
// Wait for the DOM to be fully loaded
// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", (event) => {

  // Function to fetch cart data
  function fetchCartData() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .catch((error) => {
        console.error("Error fetching cart data:", error);
        throw error; // Re-throw the error to handle it in the calling function
      });
  }

  // Function to send cart data to the backend
  function sendCartDataToBackend(cartData) {
    cartData["customer_email"] = customer_email;
    cartData["ndis_customer_id"] = ndis_customer_id;
    return fetch(
      `${base_url_NDIS_OE_APP}/pages/createDraftOrderAndInvoiceSend.php`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartData),
      }
    )
      .then((response) => response.json())
      .catch((error) => {
        console.error("Error sending cart data:", error);
        throw error; // Re-throw the error to handle it in the calling function
      });
  }

  // Event listener for the button
  let payLaterNDISClient = document.querySelector(".payLaterNDISClient");
  if (payLaterNDISClient) {
    document
      .querySelector(".payLaterNDISClient")
      .addEventListener("click", function () {
        document.querySelector(".payLaterNDISClient").disabled = true;
        document.querySelector(".payLaterNDISClient").textContent =
          "Please wait...";
        fetchCartData()
          .then((cart) => {
            return sendCartDataToBackend(cart);
          })
          .then((data) => {
            console.log("Backend response:", data);
            if(data.success){
              Swal.fire({
              title: "Success!",
              text: "Your order has been successfully submitted. An invoice has been sent to your email, allowing you to make the payment at your convenience using the link provided in the email.",
              icon: "success",
              customClass: {
                confirmButton: "Button Button--primary",
              },
              buttonsStyling: false,
            });
            }else{
               Swal.fire({
              title: "Error!",
              text: data.message,
              icon: "error",
              customClass: {
                confirmButton: "Button Button--primary",
              },
              buttonsStyling: false,
            });
            }
            document.querySelector(".payLaterNDISClient").disabled = false;
            document.querySelector(".payLaterNDISClient").textContent =
              "Pay Later";
          })
          .catch((error) => {
            console.error("Error in processing:", error);
          });
      });
  }

  // cart button pay by the NDIS Manager
  function insertItemsIntoCart(productsId, variantId) {
    let senddata = {
      productsId: productsId,
      variantId: variantId,
      customer_id: ndis_customer_id,
    };

    return fetch(`${base_url_NDIS_OE_APP}/cart/insertItemsIntoCart.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(senddata),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error("Error sending cart data:", error);
        throw error; // Re-throw the error to handle it in the calling function
      });
  }
  if (document.getElementById("paybyNDISManager")) {
    document
      .getElementById("paybyNDISManager")
      .addEventListener("click", async function () {
        let productsId = "";
        let variantId = "";
        const button = this;
        button.textContent = "Processing...";
        // Disable the button
        button.disabled = true;
        cartdata = await fetchCartData();
        if (cartdata.items.length <= 0) {
          alert("Please Add items to the cart");
        } else {
          console.log(cartdata);
          cartdata.items.forEach((item, index) => {
            productsId += item.product_id;
            variantId += item.variant_id;

            if (index !== cartdata.items.length - 1) {
              productsId += ",";
              variantId += ",";
            }
          });
          insertItemsIntoCart(productsId, variantId).then((data) => {
            console.log(data);
            button.textContent = "Pay By NDIS Manager";
            // Disable the button
            button.disabled = true;
            if (data.success) {
              Swal.fire({
                title: "Success!",
                text: "Your items are added to NDIS Manager Client. Click on the button to place the order for the NDIS Manager.",
                icon: "success",
                customClass: {
                  confirmButton: "Button Button--primary",
                },
                allowOutsideClick: false, // Disable clicking outside to close the modal
                allowEscapeKey: false, // Disable closing with the escape key
                showCancelButton: true, // Show the cancel button
                cancelButtonText: "Cancel", // Text for the cancel button
                confirmButtonText: "Review Order", // Text for the confirm button
              }).then((result) => {
                if (result.isConfirmed) {
                  // User clicked the confirm button
                  window.location.href = "/pages/ndis-cart";
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                  // User clicked the cancel button
                  console.log("User cancelled the action");
                  // You can handle the cancel action here if needed
                }
              });
            }
          });
        }
      });
  }

  // show custom login button intead of Growwave login button
    // Get the existing li element
    const sswTopauth = document.getElementById('ssw-topauth');

    // Check if the li element contains the ssw-tprofile class
    const containsProfile = sswTopauth.querySelector('.ssw-tprofile') !== null;

    // If it doesn't contain the profile structure, hide it
    if (!containsProfile) {
        sswTopauth.style.display = 'none';
       // Define the custom HTML for the new li element
        const customHtml = `
          <li class="Linklist__Item">
            <a class="Text--subdued Link Link--primary" href="/account/login">Log in</a>
          </li>
        `;

        // Append the custom HTML to the parent element
        const parentElement = sswTopauth.parentElement;
        parentElement.insertAdjacentHTML('beforeend', customHtml);
    }




});

// ============================================================================
// EWH — Returning-customer login recovery (added 2026-05-31)
// Two independent, isolated DOMContentLoaded blocks (they will not interfere
// with the NDIS/header logic above even if that block errors on a page).
//
// Block A (/account/register only): intercepts the existing "Email already
//   exists" dead-end and shows a recovery panel: Log in -> results / Forgot
//   password / Use a different email / Back to home. Stashes the guest_id so
//   the just-completed screening can be re-attached after login.
// Block B (any page, when logged in): if a pending reconcile flag is present,
//   POSTs guest_id + the real customer_id to the reconciliation endpoint so
//   the guest screening is attached to the now-authenticated account.
//
// NOTE: Block B only takes effect once servey/reconcile_guest_screening.php is
//   deployed to Bluehost. Until then it no-ops harmlessly (clears the flag).
// ============================================================================
document.addEventListener("DOMContentLoaded", function () {
  if (!/\/account\/register/.test(window.location.pathname)) return;

  function ewhResolveGuestId() {
    try {
      var u = new URL(window.location.href);
      var gid =
        u.searchParams.get("customer_id") ||
        u.searchParams.get("guest_id") ||
        u.searchParams.get("customer_id_h");
      if (gid && /^\d+$/.test(gid)) return gid;
      var keys = ["guest_customer_id", "guest_hcp_customer_id_local"];
      for (var i = 0; i < keys.length; i++) {
        var v = localStorage.getItem(keys[i]);
        if (v && /^\d+$/.test(v)) return v;
      }
      var hy = JSON.parse(localStorage.getItem("hcp_yes_no_local") || "{}");
      if (hy && hy.guest_id && /^\d+$/.test("" + hy.guest_id)) return "" + hy.guest_id;
    } catch (e) {}
    return null;
  }

  function ewhShowPanel(email) {
    if (document.getElementById("ewh-returning-panel")) return;
    var guestId = ewhResolveGuestId();
    try {
      if (guestId)
        localStorage.setItem(
          "ewh_pending_reconcile",
          JSON.stringify({ guest_id: guestId, ts: Date.now() })
        );
    } catch (e) {}

    var resultsPath = "/pages/product-recomendation";
    var loginUrl = "/account/login?return_url=" + encodeURIComponent(resultsPath);
    var recoverUrl = "/account/login#recover";
    var tmp = document.createElement("div");
    tmp.textContent = email || "";
    var emailHtml = tmp.innerHTML;

    var form = document.getElementById("create_customer");
    var panel = document.createElement("div");
    panel.id = "ewh-returning-panel";
    panel.className = "Form";
    panel.style.cssText = "text-align:center;max-width:520px;margin:0 auto;";
    panel.innerHTML =
      '<h2 class="Heading u-h3" style="margin-bottom:8px;">You already have an account</h2>' +
      '<p style="margin-bottom:18px;">It looks like <strong>' +
      emailHtml +
      "</strong> is already registered with us. Log in and we&#39;ll take you straight to your results &mdash; there&#39;s no need to start again.</p>" +
      '<a href="' +
      loginUrl +
      '" class="Button Button--primary Button--full" style="margin-bottom:10px;">Log in and see my results</a>' +
      '<a href="' +
      recoverUrl +
      '" class="Button Button--secondary Button--full" style="margin-bottom:10px;">I forgot my password</a>' +
      '<button type="button" id="ewh-different-email" class="Button Button--secondary Button--full" style="margin-bottom:10px;">Use a different email</button>' +
      '<a href="/" class="Button Button--secondary Button--full">Back to home</a>';

    if (form && form.parentNode) {
      form.style.display = "none";
      form.parentNode.insertBefore(panel, form.nextSibling);
    } else {
      document.body.appendChild(panel);
    }
    window.scrollTo(0, 0);

    var diff = document.getElementById("ewh-different-email");
    if (diff)
      diff.addEventListener("click", function () {
        if (panel.parentNode) panel.parentNode.removeChild(panel);
        if (form) form.style.display = "";
        try {
          localStorage.removeItem("ewh_pending_reconcile");
        } catch (e) {}
        var em = document.querySelector(".email_name_c");
        if (em) {
          em.value = "";
          em.focus();
        }
        var sb = document.querySelector(".Form__Submit");
        if (sb) {
          sb.disabled = false;
          sb.textContent = "Create My Account";
        }
      });
  }

  // The existing register handler sets ".cutomr_alert" to "Email already exists"
  // on collision. Watch for that and upgrade it to the recovery panel.
  var alertEl = document.querySelector(".cutomr_alert");
  if (!alertEl) return;
  var obs = new MutationObserver(function () {
    var txt = (alertEl.textContent || "").trim().toLowerCase();
    var visible = alertEl.style.display !== "none";
    if (visible && txt.indexOf("email already exists") !== -1) {
      alertEl.style.display = "none";
      var em = document.querySelector(".email_name_c");
      ewhShowPanel(em ? em.value : "");
    }
  });
  obs.observe(alertEl, {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style"],
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var cid =
    window.ShopifyAnalytics &&
    ShopifyAnalytics.meta &&
    ShopifyAnalytics.meta.page
      ? ShopifyAnalytics.meta.page.customerId
      : null;
  if (!cid) return; // only when logged in

  var pending = null;
  try {
    pending = JSON.parse(localStorage.getItem("ewh_pending_reconcile") || "null");
  } catch (e) {
    pending = null;
  }
  if (!pending || !pending.guest_id) return;
  if (pending.ts && Date.now() - pending.ts > 3600000) {
    try {
      localStorage.removeItem("ewh_pending_reconcile");
    } catch (e) {}
    return;
  }
  if (String(pending.guest_id) === String(cid)) {
    try {
      localStorage.removeItem("ewh_pending_reconcile");
    } catch (e) {}
    return;
  }
  if (typeof base_url === "undefined") return;

  var x = new XMLHttpRequest();
  x.open("POST", base_url + "/servey/reconcile_guest_screening.php", true);
  x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  x.onreadystatechange = function () {
    if (x.readyState === 4) {
      try {
        localStorage.removeItem("ewh_pending_reconcile");
      } catch (e) {}
    }
  };
  x.send(
    "guest_id=" +
      encodeURIComponent(pending.guest_id) +
      "&customer_id=" +
      encodeURIComponent(cid)
  );
});
